// extracted by mini-css-extract-plugin
module.exports = {"alert":"Toast_alert__16WXa"};